@if (state$ | async; as state) {
  <div class="soft-card">
    <p class="flex flex-row justify-between">
      <span class="mr-2 font-semibold">Profil:</span> {{ state.activeProfile }}
    </p>
    <p class="flex flex-row justify-between">
      <span class="mr-2 font-semibold">Datawedge Version:</span>
      {{ state.versionInfo?.DATAWEDGE }}
    </p>
    <div class="flex flex-row justify-end mt-4">
      <button
        class="soft-button primary"
        (click)="onResetClick()"
        [disabled]="resetting"
        >
        @if (resetting) {
          <i class="fa-regular fa-spinner fa-spin mr-2"></i>
        }
        Profil zurücksetzen
      </button>
    </div>
  </div>
}
